unit uMain;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.SideMenu, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.storage, WEBLib.REST, uHttpHelper, WEBLib.JSON,
  WEBLib.JsonData, WEBLib.ExtCtrls, WEBLib.WebCtrls, WEBLib.Buttons, uGlobal;

type
  TfrmMain = class(TForm)
    btStanding: TButton;
    pnContent: TPanel;
    btAktuell: TButton;
    btOpenClose: TSpeedButton;
    btEinstellungen: TButton;
    btAdmin: TButton;
    pnTop: TPanel;
    btClose: TSpeedButton;
    btUserName: TSpeedButton;
    btLogout: TButton;
    btWMStand: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure btStandingClick(Sender: TObject);
    procedure btOpenCloseClick(Sender: TObject);
    procedure btAktuellClick(Sender: TObject);
    procedure btAdminClick(Sender: TObject);
    procedure btLogoutClick(Sender: TObject);
    procedure btEinstellungenClick(Sender: TObject);
    procedure btWMStandClick(Sender: TObject);

  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    frm: TForm;
    [async]
    procedure SidemenuOpenClose; async;
    [async]
    procedure AdminAdjustments; async;
    procedure LoadForm(AFormClass: TFormClass);
    procedure OpenCloseMenu;
    procedure Logout;
  protected procedure LoadDFMValues; override; end;

var
  frmMain: TfrmMain;

implementation

uses
  uAktuell, uStandings, uWMStand, uAdmin, uSettings;

{$R *.dfm}

procedure TfrmMain.AdminAdjustments;
var
  status: integer;
  jo: TJSONObject;
begin
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/userisadmin/', httpGET, '', jo));
  jo.free;
  btAdmin.Visible := (status = HTTP_OK);


end;

procedure TfrmMain.btAdminClick(Sender: TObject);
begin
  LoadForm(TfrmAdmin);
  SideMenuOpenClose;
end;

procedure TfrmMain.btAktuellClick(Sender: TObject);
begin
  LoadForm(TfrmAktuell);
  SidemenuOpenClose;
end;

procedure TfrmMain.btEinstellungenClick(Sender: TObject);
begin
  LoadForm(TfrmSettings);
  SidemenuOpenClose;
end;

procedure TfrmMain.btLogoutClick(Sender: TObject);
begin
  Logout;
end;

procedure TfrmMain.btOpenCloseClick(Sender: TObject);
begin
  OpenCloseMenu;
end;

procedure TfrmMain.btStandingClick(Sender: TObject);
begin
  LoadForm(TfrmStandings);
  SidemenuOpenClose;
end;

procedure TfrmMain.btWMStandClick(Sender: TObject);
begin
  LoadForm(TfrmWMStand);
  SidemenuOpenClose;
end;

procedure TfrmMain.LoadForm(AFormClass: TFormClass);
begin
  if (assigned(frm)) then
    frm.free;

  Application.CreateForm(AFormClass, pnContent.ElementID, frm);

end;

procedure TfrmMain.Logout;
var
  ls : TLocalStorage;
begin
  //Logout
  ls := TLocalStorage.Create(nil);
  try
    ls.RemoveKey('userid');
    ls.RemoveKey('username');
    ls.RemoveKey('accesstoken');
    ls.RemoveKey('refreshtoken');
    if (assigned(frm)) then
      frm.free;
    Close;
  finally
    ls.free;
  end;

end;

procedure TfrmMain.OpenCloseMenu;
begin
  SidemenuOpenClose;
end;

procedure TfrmMain.SidemenuOpenClose;
var
  Elem: TJSHTMLElement;
  ComputedStyle: TJSCSSStyleDeclaration;
begin
  Elem := TJSHTMLElement(document.getElementsByClassName('sidebar')[0]);
  if assigned(Elem) then
  begin
    ComputedStyle := window.getComputedStyle(elem);
    if (ComputedStyle.getPropertyValue('left') = '0px') then
      Elem.style.setProperty('left', '-250px')
    else
      Elem.style.setProperty('left', '0px');
  end;
end;

procedure TfrmMain.WebFormCreate(Sender: TObject);
var
  ls: TLocalStorage;
  Elem: TJSHTMLElement;
begin
  ls := TLocalStorage.Create(nil);
  try
    btUserName.Caption := ls.GetValue('username');
  finally
    ls.free;
  end;

  //Admin Button ein-ausblenden
  AdminAdjustments;

  //Aktuell als aktives Form
  frm := nil;
  LoadForm(TfrmAktuell);
end;

procedure TfrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnTop := TPanel.Create(Self);
  pnContent := TPanel.Create(Self);
  btLogout := TButton.Create('btn-logout');
  btWMStand := TButton.Create('btn-wmstand');
  btStanding := TButton.Create('btn-standing');
  btAktuell := TButton.Create('btn-aktuell');
  btOpenClose := TSpeedButton.Create(Self);
  btEinstellungen := TButton.Create('btn-einstellungen');
  btAdmin := TButton.Create('btn-admin');
  btClose := TSpeedButton.Create('closebtn');
  btUserName := TSpeedButton.Create(Self);

  pnTop.BeforeLoadDFMValues;
  pnContent.BeforeLoadDFMValues;
  btLogout.BeforeLoadDFMValues;
  btWMStand.BeforeLoadDFMValues;
  btStanding.BeforeLoadDFMValues;
  btAktuell.BeforeLoadDFMValues;
  btOpenClose.BeforeLoadDFMValues;
  btEinstellungen.BeforeLoadDFMValues;
  btAdmin.BeforeLoadDFMValues;
  btClose.BeforeLoadDFMValues;
  btUserName.BeforeLoadDFMValues;
  try
    Name := 'frmMain';
    Width := 1072;
    Height := 565;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnTop.SetParentComponent(Self);
    pnTop.Name := 'pnTop';
    pnTop.Left := 0;
    pnTop.Top := 0;
    pnTop.Width := 1072;
    pnTop.Height := 51;
    pnTop.Align := alTop;
    pnTop.ChildOrder := 4;
    pnTop.Color := 15890688;
    pnTop.TabOrder := 6;
    pnContent.SetParentComponent(Self);
    pnContent.Name := 'pnContent';
    pnContent.Left := 0;
    pnContent.Top := 51;
    pnContent.Width := 1072;
    pnContent.Height := 514;
    pnContent.Align := alClient;
    pnContent.ChildOrder := 11;
    pnContent.TabOrder := 0;
    btLogout.SetParentComponent(pnContent);
    btLogout.Name := 'btLogout';
    btLogout.Left := 0;
    btLogout.Top := 145;
    btLogout.Width := 96;
    btLogout.Height := 25;
    btLogout.Caption := 'Logout';
    btLogout.ChildOrder := 4;
    btLogout.ElementClassName := 'text-start';
    btLogout.HeightPercent := 100.000000000000000000;
    btLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btLogout, Self, 'OnClick', 'btLogoutClick');
    btWMStand.SetParentComponent(pnContent);
    btWMStand.Name := 'btWMStand';
    btWMStand.Left := 0;
    btWMStand.Top := 82;
    btWMStand.Width := 96;
    btWMStand.Height := 27;
    btWMStand.Caption := 'WM-Stand';
    btWMStand.ChildOrder := 8;
    btWMStand.ElementClassName := 'text-start';
    btWMStand.ElementFont := efCSS;
    btWMStand.ElementPosition := epIgnore;
    btWMStand.HeightPercent := 100.000000000000000000;
    btWMStand.WidthPercent := 100.000000000000000000;
    SetEvent(btWMStand, Self, 'OnClick', 'btWMStandClick');
    btStanding.SetParentComponent(Self);
    btStanding.Name := 'btStanding';
    btStanding.Left := 0;
    btStanding.Top := 100;
    btStanding.Width := 96;
    btStanding.Height := 27;
    btStanding.Caption := 'Standing';
    btStanding.ChildOrder := 8;
    btStanding.ElementClassName := 'text-start';
    btStanding.ElementFont := efCSS;
    btStanding.ElementPosition := epIgnore;
    btStanding.HeightPercent := 100.000000000000000000;
    btStanding.WidthPercent := 100.000000000000000000;
    SetEvent(btStanding, Self, 'OnClick', 'btStandingClick');
    btAktuell.SetParentComponent(Self);
    btAktuell.Name := 'btAktuell';
    btAktuell.Left := 0;
    btAktuell.Top := 67;
    btAktuell.Width := 96;
    btAktuell.Height := 27;
    btAktuell.Caption := 'Aktuell';
    btAktuell.ChildOrder := 12;
    btAktuell.ElementClassName := 'text-start';
    btAktuell.ElementFont := efCSS;
    btAktuell.HeightPercent := 100.000000000000000000;
    btAktuell.WidthPercent := 100.000000000000000000;
    SetEvent(btAktuell, Self, 'OnClick', 'btAktuellClick');
    btOpenClose.SetParentComponent(Self);
    btOpenClose.Name := 'btOpenClose';
    btOpenClose.Left := 0;
    btOpenClose.Top := 2;
    btOpenClose.Width := 48;
    btOpenClose.Height := 48;
    btOpenClose.Color := 15890688;
    btOpenClose.ElementClassName := 'btn';
    btOpenClose.HeightPercent := 100.000000000000000000;
    btOpenClose.MaterialGlyph := 'menu';
    btOpenClose.MaterialGlyphColor := clWhite;
    btOpenClose.MaterialGlyphSize := 32;
    btOpenClose.TabOrder := 1;
    btOpenClose.WidthPercent := 100.000000000000000000;
    SetEvent(btOpenClose, Self, 'OnClick', 'btOpenCloseClick');
    btEinstellungen.SetParentComponent(Self);
    btEinstellungen.Name := 'btEinstellungen';
    btEinstellungen.Left := 0;
    btEinstellungen.Top := 166;
    btEinstellungen.Width := 96;
    btEinstellungen.Height := 25;
    btEinstellungen.Caption := 'Einstellungen';
    btEinstellungen.ChildOrder := 4;
    btEinstellungen.ElementClassName := 'text-start';
    btEinstellungen.HeightPercent := 100.000000000000000000;
    btEinstellungen.WidthPercent := 100.000000000000000000;
    SetEvent(btEinstellungen, Self, 'OnClick', 'btEinstellungenClick');
    btAdmin.SetParentComponent(Self);
    btAdmin.Name := 'btAdmin';
    btAdmin.Left := 0;
    btAdmin.Top := 226;
    btAdmin.Width := 96;
    btAdmin.Height := 25;
    btAdmin.Caption := 'Admin';
    btAdmin.ChildOrder := 1;
    btAdmin.ElementClassName := 'text-start';
    btAdmin.HeightPercent := 100.000000000000000000;
    btAdmin.Visible := False;
    btAdmin.WidthPercent := 100.000000000000000000;
    SetEvent(btAdmin, Self, 'OnClick', 'btAdminClick');
    btClose.SetParentComponent(Self);
    btClose.Name := 'btClose';
    btClose.Left := 54;
    btClose.Top := 3;
    btClose.Width := 48;
    btClose.Height := 48;
    btClose.Color := clNone;
    btClose.ElementClassName := 'close-btn btn';
    btClose.HeightPercent := 100.000000000000000000;
    btClose.MaterialGlyph := 'close';
    btClose.MaterialGlyphSize := 32;
    btClose.TabOrder := 7;
    btClose.WidthPercent := 100.000000000000000000;
    SetEvent(btClose, Self, 'OnClick', 'btOpenCloseClick');
    btUserName.SetParentComponent(Self);
    btUserName.Name := 'btUserName';
    btUserName.Left := 912;
    btUserName.Top := 9;
    btUserName.Width := 159;
    btUserName.Height := 33;
    btUserName.Anchors := [akTop,akRight];
    btUserName.Caption := 'Username';
    btUserName.Color := 15890688;
    btUserName.ElementClassName := 'btn text-end userlabel';
    btUserName.ElementFont := efCSS;
    btUserName.Font.Charset := DEFAULT_CHARSET;
    btUserName.Font.Color := clWhite;
    btUserName.Font.Height := -16;
    btUserName.Font.Name := 'Arial';
    btUserName.Font.Style := [fsBold];
    btUserName.HeightPercent := 100.000000000000000000;
    btUserName.MaterialGlyph := 'account_circle';
    btUserName.MaterialGlyphColor := clWhite;
    btUserName.MaterialGlyphSize := 32;
    btUserName.ParentFont := False;
    btUserName.TabOrder := 8;
    btUserName.WidthPercent := 100.000000000000000000;
  finally
    pnTop.AfterLoadDFMValues;
    pnContent.AfterLoadDFMValues;
    btLogout.AfterLoadDFMValues;
    btWMStand.AfterLoadDFMValues;
    btStanding.AfterLoadDFMValues;
    btAktuell.AfterLoadDFMValues;
    btOpenClose.AfterLoadDFMValues;
    btEinstellungen.AfterLoadDFMValues;
    btAdmin.AfterLoadDFMValues;
    btClose.AfterLoadDFMValues;
    btUserName.AfterLoadDFMValues;
  end;
end;

end.